export default "__VITE_ASSET__77d1ad13__"